<template>
  <div class="select-warp" v-click-outside="hide">
    <div class="coinSelect" @click="isDrop = !isDrop" v-bind:class="[isDrop ? 'active' :'']">
      <div class="coinBox" v-if="value">
        <span class="coinIcon" :style="`background-image: url(https://event.bitforex.com/assets/coin/${selectedOption.label}m.png)`"></span>
        <span class="coin-code">{{selectedOption.label}}</span>
        <svg class="ficon icon-drop" :class="[isDrop ? 'active' :'']" aria-hidden="true">
          <use xlink:href="#bf-icon_cutover"></use>
        </svg>
      </div>
    </div>
    <div class="coinList" :class="{'showList': isDrop}">
      <ul>
        <li v-for="item in options" :key="item.key" @click="selectFun(item)" :class="{'hover': item.value == value}">
          <div class="coinBox">
            <span class="coinIcon" :style="`background-image: url(https://event.bitforex.com/assets/coin/${item.label}m.png)`"></span>
            <span class="coin-code">{{item.label}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Select',
  props: {
    value: {
      type: String
    },
    options: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isDrop: false
    };
  },
  computed: {
    selectedOption () {
      return this.options.find(o => {
        return o.value === this.value;
      });
    }
  },
  methods: {
    // 选择币种
    selectFun (item) {
      this.isDrop = !this.isDrop;
      this.$emit('input', item.value);
    },
    hide () {
      this.isDrop = false;
    }
  }
};
</script>
<style lang="scss" scoped>

@import "./select.scss";

</style>
